import { render, staticRenderFns } from "./CGMDetails.vue?vue&type=template&id=61b84cc8&scoped=true"
import script from "./CGMDetails.vue?vue&type=script&lang=js"
export * from "./CGMDetails.vue?vue&type=script&lang=js"
import style0 from "./CGMDetails.vue?vue&type=style&index=0&id=61b84cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b84cc8",
  null
  
)

export default component.exports